export default "__VITE_ASSET__b05a8d0e__"